var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecoveryplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9244_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9244_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4719 2.00009C10.7496 1.99294 9.02555 2.43428 7.47986 3.32498C5.13727 4.67488 3.47743 6.9012 2.80964 9.45768C2.78745 9.54275 2.84216 9.62876 2.92858 9.64465L5.40838 10.0975C5.48006 10.1105 5.55081 10.0705 5.57668 10.0024C6.74623 6.91663 9.40164 4.83416 12.4176 4.82885C14.8361 4.83193 17.0181 6.17121 18.3944 8.29017L17.015 8.51444C16.8883 8.53519 16.8367 8.6589 16.922 8.73737L20.8214 12.3139C20.9069 12.3926 21.0657 12.367 21.1073 12.2679L22.991 7.75087C23.0271 7.66416 22.9498 7.57825 22.8449 7.5719C22.8299 7.57104 22.8143 7.57173 22.7985 7.5743L21.4511 7.79324C20.6113 5.97295 19.2362 4.4138 17.4529 3.36638C15.9145 2.4629 14.1941 2.00723 12.4719 2.00009ZM11.3055 7.96394C11.1994 7.96393 11.1135 8.04993 11.1134 8.15605V10.5526L8.76357 10.5488C8.65751 10.5487 8.5714 10.6345 8.57122 10.7407L8.56713 13.2864C8.56697 13.3925 8.6528 13.4786 8.75886 13.4788L11.1134 13.4826V15.793C11.1134 15.8991 11.1994 15.9852 11.3055 15.9852H13.8496C13.9557 15.9852 14.0417 15.8991 14.0417 15.793V13.4874L16.3913 13.4912C16.4974 13.4913 16.5835 13.4054 16.5837 13.2993L16.5878 10.7536C16.5879 10.6475 16.5021 10.5613 16.396 10.5612L14.0417 10.5573V8.15623C14.0417 8.05011 13.9557 7.96411 13.8497 7.96412L11.3055 7.96394ZM4.06334 11.6401C4.04874 11.6393 4.03387 11.6401 4.01913 11.6424C3.96016 11.6519 3.91193 11.6861 3.89264 11.7321L2.00899 16.2491C1.96776 16.3482 2.07465 16.4463 2.20151 16.4257L3.54878 16.2067C4.38863 18.027 5.76372 19.5862 7.54715 20.6336C10.6238 22.4406 14.4287 22.4563 17.52 20.6749C19.8626 19.325 21.5226 17.0988 22.1904 14.5423C22.2126 14.4572 22.1579 14.3712 22.0714 14.3553L19.5916 13.9025C19.5737 13.8992 19.5558 13.8993 19.5387 13.9023C19.4874 13.9113 19.4427 13.9465 19.4233 13.9976C18.2538 17.0834 15.5983 19.1659 12.5823 19.1712C10.1638 19.1681 7.98186 17.8287 6.60563 15.7098L7.98493 15.4855C8.11169 15.4648 8.16331 15.341 8.07796 15.2626L4.17847 11.686C4.14873 11.6587 4.10714 11.6425 4.06334 11.6401Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryplan);
export default __webpack_public_path__ + "static/media/recovery plan.b2d0991a41bcb24dddfc9410b8f5e94a.svg";
export { ForwardRef as ReactComponent };